import { copy } from "shared/assets";
import { IFieldType, IFormFields } from "shared/types";
import { TravelLegFieldsProps } from "../EventFlightTravelLegForm/formData";

const errors = copy.errors;
const travelLegFields = copy.travelBlock.travelLeg.fields;
const travelLegMessages = copy.travelBlock.travelLeg.messages;
const groundTransportFields = copy.travelBlock.groundTransport.fields;

export const getFields = ({
  suggestedLocations = [],
  timeFormat,
  dateFormat,
  handleStartDateChange,
  handleEndDateChange,
  isStartBeforeEnd,
  fetchGoogleLocations,
  isFetchingLocations,
  resetLocations,
  onSelectDeparture,
  onSelectArrival,
}: TravelLegFieldsProps): IFormFields => [
  {
    name: "transportMode",
    label: groundTransportFields.transportMode,
    type: IFieldType.text,
    validation: {
      required: errors.required,
    },
    style: {
      gridColumn: "span 6",
    },
  },
  {
    name: "departure.location",
    label: travelLegFields.departure,
    placeholder: travelLegFields.chooseLocation,
    type: IFieldType.select,
    options: suggestedLocations,
    isLoading: isFetchingLocations,
    isSearchable: true,
    onInputChange: (newValue, actionMeta) => {
      if (actionMeta.action === "input-change") {
        fetchGoogleLocations(newValue);
      }
    },
    onDropdownClose: resetLocations,
    onChange: onSelectDeparture,
    validation: {
      required: errors.required,
    },
    style: {
      gridColumn: "span 3",
    },
  },
  {
    name: "arrival.location",
    label: travelLegFields.destination,
    placeholder: travelLegFields.chooseLocation,
    type: IFieldType.select,
    options: suggestedLocations,
    isLoading: isFetchingLocations,
    isSearchable: true,
    onInputChange: (newValue, actionMeta) => {
      if (actionMeta.action === "input-change") {
        fetchGoogleLocations(newValue);
      }
    },
    onDropdownClose: resetLocations,
    onChange: onSelectArrival,
    validation: {
      required: errors.required,
    },
    style: {
      gridColumn: "span 3",
    },
  },
  {
    name: "departure.date",
    label: travelLegFields.departureDate,
    type: IFieldType.datePicker,
    dateFormat,
    validation: {
      required: errors.required,
      validate: () => isStartBeforeEnd || travelLegMessages.startBeforeEnd,
    },
    onChange: (value: string) => handleStartDateChange({ date: value }),
    style: {
      gridColumn: "span 2",
      mobile: {
        gridColumn: "span 3",
      },
    },
  },
  {
    name: "departure.time",
    label: travelLegFields.departureTime,
    type: IFieldType.simpleTime,
    timeFormat,
    validation: {
      required: errors.required,
      validate: () => isStartBeforeEnd,
    },
    onChange: (value: string) => handleStartDateChange({ time: value }),
    style: {
      gridColumn: "span 2",
      mobile: {
        gridColumn: "span 3",
      },
    },
  },
  {
    name: "departure.timeZone",
    label: travelLegFields.departureTimeZone,
    type: IFieldType.timezone,
    validation: {
      required: errors.required,
      validate: () => isStartBeforeEnd,
    },
    onChange: (data?: { value: string }) =>
      data?.value && handleStartDateChange({ timeZone: data.value }),
    style: {
      gridColumn: "span 2",
      mobile: {
        gridColumn: "span 6",
      },
    },
  },
  {
    name: "arrival.date",
    label: travelLegFields.arrivalDate,
    type: IFieldType.datePicker,
    dateFormat,
    validation: {
      required: errors.required,
    },
    onChange: (value: string) => handleEndDateChange({ date: value }),
    style: {
      gridColumn: "span 2",
      mobile: {
        gridColumn: "span 3",
      },
    },
  },
  {
    name: "arrival.time",
    label: travelLegFields.arrivalTime,
    timeFormat,
    type: IFieldType.simpleTime,
    validation: {
      required: errors.required,
    },
    onChange: (value: string) => handleEndDateChange({ time: value }),
    style: {
      gridColumn: "span 2",
      mobile: {
        gridColumn: "span 3",
      },
    },
  },
  {
    name: "arrival.timeZone",
    label: travelLegFields.arrivalTimeZone,
    type: IFieldType.timezone,
    validation: {
      required: errors.required,
    },
    onChange: (data?: { value: string }) =>
      data?.value && handleEndDateChange({ timeZone: data.value }),
    style: {
      gridColumn: "span 2",
      mobile: {
        gridColumn: "span 6",
      },
    },
  },
  {
    name: "info",
    label: travelLegFields.info,
    type: IFieldType.rte,
    style: {
      gridColumn: "span 6",
    },
  },
];
